<template>
  <div class="container">
    <div>
      <mad-form @submit.prevent="submit">
        <div v-if="error" class="alert alert-danger" role="alert">
          {{ error }}
        </div>
        <mad-form-item label="Password">
          <mad-input v-model="form.new_password" type="password" />
        </mad-form-item>
        <mad-form-item label="Confirm password">
          <mad-input v-model="form.confirmed_password" type="password" />
        </mad-form-item>

        <div class="spaced-row">
          <mad-button @click="clickCancel">
            <mad-icon mdi="arrow-left" />
          </mad-button>
          <div class="grow"></div>

          <mad-button color="brown" type="submit" @click="submit(form.password)">
            <mad-icon mdi="check" />
            Save
          </mad-button>
        </div>
      </mad-form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    token: { type: String, required: true },
  },

  data: () => ({
    form: {
      new_password: '',
      confirmed_password: '',
    },
    error: null,
  }),

  methods: {
    async submit(newPassword) {
      if (newPassword !== this.confirmed_password) {
        this.error = 'Confirmed password must be identical to your new password'
      } else {
        const token = this.token
        const user = await this.$store.dispatch('resetPassword', { newPassword, token })
        await this.$mad.message.success('Password has been reset')

        await this.$store.dispatch('login', {
          email: user.email,
          password: newPassword,
        })
        this.$router.push('/locations')
      }
    },

    clickCancel() {
      this.$router.push(`/login`)
    },
  },
}
</script>

<style>
</style>
